var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popbox",class:_vm.disabled ? 'disabled' : '',on:{"mouseover":_vm.debounce,"click":_vm.emit,"mouseleave":_vm.debounceClose}},[_c('div',{staticClass:"popitem"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }